import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

export interface FlashMessageProps {
  message: string | null;
  type?: 'success' | 'error';
  onDismiss?: () => void;
}

export const FlashMessage: React.FC<FlashMessageProps> = ({ message, type = 'success', onDismiss }) => {
  if (!message) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -50, scale: 0.9 }}
        transition={{ duration: 0.2 }}
        className="fixed top-20 left-1/2 -translate-x-1/2 z-[100]"
        onClick={onDismiss}
      >
        <div
          className={`
            flex items-center gap-3 px-6 py-3 rounded-lg shadow-2xl
            ${type === 'success' ? 'bg-green-500' : 'bg-red-500'}
            text-white font-medium
            cursor-pointer hover:scale-105 transition-transform
          `}
        >
          {type === 'success' ? (
            <CheckCircleIcon className="w-6 h-6" />
          ) : (
            <XCircleIcon className="w-6 h-6" />
          )}
          <span>{message}</span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
